export default __webpack_public_path__ + "static/media/animal-btn.88fb16f3.jpg";